// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1171127db99dd5a739ef","293":"2b2b92fea5611483bc1c","518":"027e817bc589122a21ff","779":"c618bc8271f122c9e832"}[chunkId] + ".js";
};